<template>
  <div>
    <div class="d-inline-block w-50 mt-1">
      <title-breadcrumb :page="page" />
    </div>
    <router-view />
  </div>
</template>

<script>
import TitleBreadcrumb from 'TitleBreadCrumb'

export default {
  name: 'InterfacesHome',
  components: { TitleBreadcrumb },
  data: () => ({
    page: {
      title: 'Navegaciones',
      icon: 'fas fa-shield-alt',
      routes: ['Navegaciones'],
    },
  }),
  provide() {
    return {
      page: this.page,
    }
  },
}
</script>
